import posthog from "posthog-js";

let posthogInitialized = false;

export interface FeedbackResponse {
    rating: "bad" | "neutral" | "great";
    query: string;
    resourceCount?: number;
    timestamp: Date;
    userId?: string;
}

export interface SurveyConfig {
    id: string;
    question: string;
    type: "rating" | "multiple_choice" | "text";
    options?: string[];
}

export function initPosthogClient(): void {
    if (posthogInitialized) return;
    if (typeof window === "undefined") return;

    const token = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
    const apiHost = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || "https://app.posthog.com";

    if (!token) {
        // Silently skip when not configured
        posthogInitialized = true;
        return;
    }

    posthog.init(token, {
        api_host: apiHost,
        autocapture: true,
        capture_pageview: true,
        capture_pageleave: true,
        opt_in_site_apps: true,
        // Keep replays safe by default
        session_recording: {
            maskAllInputs: true,
        },
        ui_host: apiHost,
    });

    // Ensure session recording is active when available at runtime
    try {
        (posthog as unknown as { startSessionRecording?: () => void }).startSessionRecording?.();
    } catch { }

    posthogInitialized = true;
}


export { posthog };


